import React, { useState,useEffect } from "react";
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import SelectDate from "../components/popups/SelectDate";
import { ChangeDateStringOnlyDate,ChangeDateFormat,isNull,ToggleDarkBackground } from "../../components/common/Common";

import centerIcon from "../../img/icon/icon-center-class-03.svg";
import "../../css/style.css";

//비밀번호 찾기
const SemesterCopy = () => {
  const { sm_idx } = useParams();
  const navigate = useNavigate();
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  //학기정보
  const [varSemesterInfo,setSemesterInfo] = useState({});
  //클래스 내역
  const [varClassList,setClassList] = useState([]);

  //학기정보 호출
  const GetSemsterInformation = async() => {
    const sendData = {sm_idx:sm_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_current_semester_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results.length > 0){
          const dataInfo = datas.results[0];
          dataInfo.sm_idx = 0;
          dataInfo.sm_org_name = dataInfo.sm_name;
          dataInfo.sm_name = "";
          dataInfo.sm_sdate = "";
          dataInfo.sm_edate = "";
          dataInfo.sm_rdate = ChangeDateFormat('');
          setSemesterInfo(dataInfo);
        } 
        if(datas.classes.length > 0) setClassList(datas.classes);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});

    GetSemsterInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //정보입력부
  const onChangeInputHandler = (e) => {
    const { name, value } = e.currentTarget;
    setSemesterInfo({...varSemesterInfo,[name]:value});
  }

  //날짜선택 팝업창
  const [varPopupDaySelect,setPopupDaySelect] = useState(false);  //팝업창 열기/닫기
  const [varDate,setDate] = useState(null); //선택된 날짜
  const [varDateMode,setDateMode] = useState(0);  //날짜 항목
  const [varFromDate,setFromDate] = useState(null);
  const onChangeDateHandler = (e,imode) => {
    setDateMode(imode);
    const sdate = new Date(varSemesterInfo.sm_sdate);
    if(imode === 1) {
      setFromDate(new Date());
      setDate(sdate);
    } else {
      const edate = new Date(varSemesterInfo.sm_edate);
      setFromDate(sdate);
      setDate(edate);
    }
    TogglePopupDaySelect(true);
  }
  const TogglePopupDaySelect = (bmode) => {
    setPopupDaySelect(bmode);
    ToggleDarkBackground(bmode);
  }
  //검색기간 설정값 저장
  const ChangedDate = (ino,date) => {
    if(date === "" ) date = null;
    const ndate = ChangeDateFormat(date);
    if(ino === 1){ 
      setSemesterInfo({...varSemesterInfo,sm_sdate:ndate});
    } else {
      setSemesterInfo({...varSemesterInfo,sm_edate:ndate});
    }
    TogglePopupDaySelect(false);
  }
  

  //학기등록
  const onUpdateSemesterHandler = async(e) => {
    if(isNull(varSemesterInfo.sm_name)) {
      alert('학기명을 먼저 입력하세요.'); return false;
    } else if(isNull(varSemesterInfo.sm_sdate)) {
      alert('개강일을 먼저 선택하세요.'); return false;
    } else if(isNull(varSemesterInfo.sm_edate)) {
      alert('종강일을 먼저 선택하세요하세요.'); return false;
    }

    if(!window.confirm('지정된 학기의 정보를 복사하여 저장하시겠습니까?')) return false;
    const sendData = {dataInfo:varSemesterInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_copy_semester`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const newIndex = datas.newIndex;
        CopyClasses(newIndex);
      } else {
        alert(datas.message);
      }
    });
  }

  //클래스복사
  const CopyClasses = async(newIndex) => {
    const sendData = {sm_idx:newIndex,classList:varClassList};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_copy_semester_classes`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        navigate('/Branch/SemesterSet');
      } else {
        alert(datas.message);
      }
    });
  }

  return (
    <div className="vh-content" style={{minHeight:"100vh"}}>
      <HeaderBranchTitle varPageTitle={'학기 복사'} varBackString={'/Branch/SemesterSet'}/>
      <div className="vh-content-body">
        <div className="cl-setting-form-wrap">
          <div className="form-group mb15" style={{display:"flex",justifyContent:"start"}}>
            <label className="form-label">복사할 학기 : </label><div style={{fontSize:"14px",marginLeft:"20px"}}>{varSemesterInfo.sm_org_name}</div>
          </div>
          <div className="form-group mb15">
            <label className="form-label">학기명</label>
            <div className="field-group">
              <input type="text" name="sm_name" className="form-control" placeholder="학기명을 입력하세요." value={varSemesterInfo.sm_name||""} onChange={e=>onChangeInputHandler(e)}/>
            </div>
          </div>

          <div className="form-group mb15">
            <label className="form-label">개강일</label>
            <div className="field-group flex">
              <div className="has-btn">
                <input type="text" value={ChangeDateStringOnlyDate(varSemesterInfo.sm_sdate)||""} name="sm_sdate" className="input-cal" disabled/>
                <button className="cal-btn" onClick={e=>onChangeDateHandler(e,1)}><img src={centerIcon} alt=""/></button>
              </div>
            </div>
          </div>
          
          <div className="form-group mb15">
            <label className="form-label">종강일</label>
            <div className="field-group flex">
              <div className="has-btn">
                <input type="text" value={ChangeDateStringOnlyDate(varSemesterInfo.sm_edate)||""} name="sm_edate" className="input-cal" disabled/>
                <button className="cal-btn" onClick={e=>onChangeDateHandler(e,2)}><img src={centerIcon} alt=""/></button>
              </div>								
            </div>
          </div>
          
          <div className="class-date">
            <div>등록일 : {ChangeDateStringOnlyDate(varSemesterInfo.sm_rdate)||""}</div>
          </div>

          <div className="form-contoller bt-btn">
            <Link to={'/Branch/SemesterSet'} className="form-contoller-btn btn-no" style={{width:"48%"}}>취소</Link>
            <button className="form-contoller-btn btn-yes" onClick={e=>onUpdateSemesterHandler(e)} style={{marginRight:"0"}}>복사</button>
          </div>
        </div>
      </div>
      <SelectDate varDate={varDate} setDate={setDate} varDateMode={varDateMode} varFromDate={varFromDate}
              varPopupDaySelect={varPopupDaySelect} TogglePopupDaySelect={TogglePopupDaySelect} 
              ChangedDate={ChangedDate}/>
    </div>	
  );
}
export default SemesterCopy;